import { ArrowRight } from "lucide-react";

const FEATURED = [
  { value: 201, cipher: "Ordinal",   phrase: "The Jesuit Order",      note: "201 = signature of the Society of Jesus · Hubbard's calling card" },
  { value: 97,  cipher: "Rev. Ord.", phrase: "Death",                  note: "97 = the death cipher · matches countless ritual hits" },
  { value: 74,  cipher: "Ordinal",   phrase: "Killing",                note: "74 = Jewish · Lucifer · Gospel · Occult · Masonic" },
  { value: 111, cipher: "Ordinal",   phrase: "The Illusion",           note: "111 = his signature · scripted matrix · new beginnings" },
  { value: 56,  cipher: "Reduction", phrase: "Society of Jesus",       note: "56 = Coronavirus · Pope Francis · Washington D.C." },
  { value: 66,  cipher: "Reduction", phrase: "Jacob Rothschild",       note: "Died 6yr 6mo 6d after 8/21/17 eclipse" },
  { value: 333, cipher: "Day of yr", phrase: "William A. De Rothschild", note: "Died 333rd day · 33 days left · fire took 33 min" },
  { value: 87,  cipher: "Ordinal",   phrase: "Six Six Six",            note: "William De Rothschild died at 87 · six-six-six = 87" },
  { value: 33,  cipher: "Reduction", phrase: "Masonry",                note: "Highest Scottish Rite degree · Hubbard's ritual number" },
];

export default function FeaturedGrid({ onPick }) {
  return (
    <div className="rise rise-2 space-y-5">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] muted mb-2">
            // Featured Decodes
          </div>
          <h2 className="font-display text-2xl md:text-3xl tracking-tight">
            Start with a <span className="gold italic">famous</span> number
          </h2>
        </div>
        <div className="font-mono text-[10px] muted uppercase tracking-wider hidden sm:block">
          Click to decode
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {FEATURED.map((f) => (
          <button
            key={f.value}
            data-testid={`featured-${f.value}`}
            onClick={() => onPick(f.value)}
            className="panel panel-hover p-5 text-left group transition-transform hover:-translate-y-[2px]"
          >
            <div className="flex items-baseline justify-between gap-3 mb-2">
              <div className="big-number font-display text-4xl text-[var(--primary)] leading-none">
                {f.value}
              </div>
              <div className="font-mono text-[9px] uppercase tracking-[0.18em] muted">
                {f.cipher}
              </div>
            </div>
            <div className="font-display text-lg leading-snug">{f.phrase}</div>
            <div className="muted text-xs mt-2 font-mono leading-relaxed">{f.note}</div>
            <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.18em] gold opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
              Decode <ArrowRight size={10} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
